import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { Link } from "react-router-dom";
import Header from "../../components/Header";
import HeaderBanner from "../../components/HeaderBanner";
import { db } from "../../firebase";
import { useHistory } from "react-router-dom";
import Footer from "../../components/Footer";

function MentorDashboard({ match }) {
  const { currentUser } = useAuth();
  const [user, setUser] = useState({});
  const history = useHistory();

  // console.log(currentUser.providerData[0].providerId)

  useEffect(() => {
    if (sessionStorage.getItem("authUser") == null || undefined) {
      const fetchUserData = async () => {
        return await db
          .collection("mentors")
          .doc(currentUser.uid)
          .get()
          .then((doc) => {
            setUser(doc.data());
            sessionStorage.setItem("authUser", JSON.stringify(doc.data()));
          });
      };
      fetchUserData();
    } else {
      setUser(JSON.parse(sessionStorage.getItem("authUser")));
    }
    if (sessionStorage.getItem("authUser")) {
      let data = JSON.parse(sessionStorage.getItem("authUser"));
      if (!data.hasOwnProperty("invites")) {
        history.push("/member/dashboard");
      }
    }
  }, [currentUser, history]);

  return (
    <>
      <Header />
      <HeaderBanner user={user} />
      <div className="container  mx-auto px-4 sm:px-2">
        <div className="mt-8 sm:mt-8 w-full">
          <div className="flex justify-between">
            <div>
              <h1 className="text-3xl font-semibold mb-1 text-gray-600">
                Hello,{" "}
                <span className="text-gray-900">{currentUser.displayName}</span>
              </h1>
              <h2 className="font-medium mb-1 text-gray-600 leading-relaxed">
                {currentUser.email}
              </h2>
            </div>
            {user.hasOwnProperty("status") && user.status && (
              <div className="mt-4">
                <a
                  href={`/mentor/${user.username}`}
                  class="flex items-center px-4 py-2 w-40 transition ease-in duration-200 rounded-full hover:bg-blue-500 hover:text-white border border-gray-900 hover:border-white focus:outline-none text-md"
                >
                  Public Profile
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5 ml-2"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                    />
                  </svg>
                </a>
              </div>
            )}
          </div>
          <div className="mt-8">
            <h3 className="text-xl font-semibold mb-4">Account</h3>
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 sm:col-span-6 md:col-span-4">
                <Link to="/mentor/info">
                  <div className="flex flex-row bg-white border border-gray-300 rounded-lg p-8">
                    <div className="flex items-center justify-center flex-shrink-0 h-12 w-12 rounded-xl bg-blue-100 text-blue-500">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                        />
                      </svg>
                    </div>
                    <div className="flex flex-col flex-grow ml-4">
                      <div className="font-bold text-lg">
                        Personal Information
                      </div>
                      <div className="text-sm text-gray-500 mt-1">
                        Provide personal details and how we can reach you
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
              <div className="col-span-12 sm:col-span-6 md:col-span-4">
                <Link to="/login-and-security">
                  <div className="flex flex-row bg-white border border-gray-300 rounded-lg p-8">
                    <div className="flex items-center justify-center flex-shrink-0 h-12 w-12 rounded-xl bg-red-100 text-blue-500">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="red"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                        />
                      </svg>
                    </div>
                    <div className="flex flex-col flex-grow ml-4">
                      <div className="font-bold text-lg">Login & Security</div>
                      <div className="text-sm text-gray-500 mt-1">
                        Update your password and other social accounts
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
              <div className="col-span-12 sm:col-span-6 md:col-span-4">
                <Link to="/feedback-and-support">
                  <div className="flex flex-row bg-white border border-gray-300 rounded-lg p-8">
                    <div className="flex items-center justify-center flex-shrink-0 h-12 w-12 rounded-xl bg-green-100 text-blue-500">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="green"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z"
                        />
                      </svg>
                    </div>
                    <div className="flex flex-col flex-grow ml-4">
                      <div className="font-bold text-lg">
                        Feedback and Support
                      </div>
                      <div className="text-sm text-gray-500 mt-1">
                        Ask us anything and share your feedback with us
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div>

          <div className="mt-8 mb-16">
            <h3 className="text-xl font-semibold mb-4">My Activities</h3>
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 sm:col-span-6 md:col-span-4">
                <Link to="/mentor/profile-status">
                  <div className="flex flex-row bg-white border border-gray-300 rounded-lg p-8">
                    <div className="flex items-center justify-center flex-shrink-0 h-12 w-12 rounded-xl bg-purple-100 text-blue-500">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="purple"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M5.636 18.364a9 9 0 010-12.728m12.728 0a9 9 0 010 12.728m-9.9-2.829a5 5 0 010-7.07m7.072 0a5 5 0 010 7.07M13 12a1 1 0 11-2 0 1 1 0 012 0z"
                        />
                      </svg>
                    </div>
                    <div className="flex flex-col flex-grow ml-4">
                      <div className="font-bold text-lg">Profile Status</div>
                      <div className="text-sm text-gray-500 mt-1">
                        Set visibility of your profile across the mentees
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
              <div className="col-span-12 sm:col-span-6 md:col-span-4 ">
                <div className="flex flex-row bg-white border border-gray-300 rounded-lg p-8 ">
                  <div className="flex items-center justify-center flex-shrink-0 h-12 w-12 rounded-xl bg-yellow-100 text-blue-500">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="orange"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M13 10V3L4 14h7v7l9-11h-7z"
                      />
                    </svg>
                  </div>
                  <div className="flex flex-col flex-grow ml-4 ">
                    <div className="font-bold text-lg">Invite Mentors</div>
                    <div className="text-sm text-gray-500 mt-1 ">
                      Use this superpower to invite other Superheros like you
                    </div>
                  </div>
                  <div className="relative">
                    <span class="absolute w-max right-0 -mt-12 -mr-4 text-sm font-medium bg-red-100 py-1 px-2 rounded-lg text-red-500 align-middle">
                      coming soon
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>{" "}
      <Footer />
    </>
  );
}

export default MentorDashboard;
